import { isPractitionerEvent, isPractitionerRole } from './posthogEventRouting';

/**
 * Devuelve el cliente PostHog al que enviar el evento:
 * - Psicólogo -> window.__posthogPsychologist (UAT o Prod según entorno)
 * - Paciente/resto -> window.__posthogPatient (solo en prod, via proxy)
 */
function getPostHogClientForEvent(eventName, properties) {
  if (isPractitionerEvent(eventName, properties)) {
    return typeof window !== 'undefined' ? window.__posthogPsychologist : null;
  }
  return typeof window !== 'undefined' ? window.__posthogPatient : null;
}

/**
 * Devuelve el cliente PostHog para identify según rol:
 * - SPECIALIST/SUPERVISOR -> psicólogo
 * - Resto (PATIENT, etc.) -> paciente (solo en prod)
 */
function getPostHogClientForIdentify(role) {
  if (typeof window === 'undefined') return null;
  if (isPractitionerRole(role)) return window.__posthogPsychologist;
  return window.__posthogPatient;
}

export default class ProductAnalytics {

    trackEvent(eventName, properties) {
        if (window.mixpanel) window.mixpanel.track(eventName, properties);
        if (window.zaraz) window.zaraz.track(eventName, {ga: true, ...properties});
        const client = getPostHogClientForEvent(eventName, properties || {});
        if (client) client.capture(eventName, properties);
        if (window._cio) window._cio.track(eventName, {});
        if (window.smartlook) window.smartlook('track', eventName, properties);
    }

    identify(email, userId, role = null) {
        const client = getPostHogClientForIdentify(role);
        if (client) {
            const identifyData = { role: role };
            client.identify(userId, identifyData);
        }
        if (window._cio) window._cio.identify({id: userId, email: email});
        if (window.clarity) window.clarity("identify", userId);
        if (window.smartlook) window.smartlook('identify', userId);
    }

    // Función helper para identificar usuarios con datos completos
    identifyUser(userDetails) {
        if (!userDetails || !userDetails.email || !userDetails.userId) {
            console.warn('ProductAnalytics: Datos de usuario incompletos para identificación');
            return;
        }

        this.identify(userDetails.email, userDetails.userId, userDetails.role);
    }

    track(eventName, properties) {
        const props = properties || {};
        const client = getPostHogClientForEvent(eventName, props);
        if (client) {
            if (window.postHogInterval) clearInterval(window.postHogInterval);
            this.iteratePendingEvents();
            client.capture(eventName, props);
        } else {
            if (window.postHogEvent) {
                window.postHogEvent.push({ name: eventName, properties: props });
            } else {
                window.postHogEvent = [{ name: eventName, properties: props }];
            }
            if (!window.postHogInterval) {
                window.postHogInterval = setInterval(() => this.iteratePendingEvents(), 3000);
            }
        }
        try {
            if (window.mixpanel) window.mixpanel.track(eventName, props);
            if (window.zaraz) window.zaraz.track(eventName, { ga: true, ...props });
            if (window._cio) window._cio.track(eventName, {});
        } catch (e) {
            console.error("Error");
        }
    }

    iteratePendingEvents() {
        const psych = window.__posthogPsychologist;
        const patient = window.__posthogPatient;
        const client = psych || patient;
        if (client && window.postHogEvent && window.postHogEvent.length > 0) {
            const length = window.postHogEvent.length;
            for (let i = 1; i <= length; i++) {
                const event = window.postHogEvent.shift();
                const c = getPostHogClientForEvent(event.name, event.properties);
                if (c) c.capture(event.name, event.properties);
            }
        }
    }
}
